/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

// Starting point of client side applicaton
import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import axios from "axios";

import Routes, { headerRoutes, footerRoutes } from "./Routes";
import reducers from "./reducers";

import { ThemeProvider } from "@material-ui/styles";
import { theme } from "../helpers/mui";
import { isProd } from "assets/jss/views/PhoenixCommons";

// create a customized axios for Client
const axiosInstance = axios.create({
  // when using this instance, it'll always be prepended '/prx'. Since we setup
  // a proxy where anything starts with /prx will be sent to API server
  baseURL: "/prx",
});

const composeEnhancers =
  (process.env.NODE_ENV !== "production" &&
    typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

// To use 'trace', set composeEnhancers as below. However, it breaks Safari.
// (Problem: Header cannot be opaque, button not responding...)
// const composeEnhancers =
//   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true }) || compose;

const store = createStore(
  reducers,
  window.INITIAL_STATE, // the 2nd parameter of createStore is the initial data
  isProd
    ? applyMiddleware(thunk.withExtraArgument(axiosInstance))
    : composeEnhancers(applyMiddleware(thunk.withExtraArgument(axiosInstance))),
);

function Main() {
  React.useEffect(() => {
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <div>{renderRoutes(Routes, { headerRoutes, footerRoutes })}</div>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

ReactDOM.hydrate(<Main />, document.querySelector("#root"));
